/* eslint-disable no-unused-vars */
import React, { useMemo } from 'react';
import { AdvancedMarker, InfoWindow, useAdvancedMarkerRef } from '@vis.gl/react-google-maps';
import { VehicleInfoWindow, StopInfoWindow, StopsInfoWindow } from './InfoWindow';
import './Marker.scss';
import { STEP_TYPE } from '../../constants';
import { useSelector } from 'react-redux';

const Marker = React.memo(({ position, icon, active, onToggle, item, items, disableInfoWindow = false }) => {
  const [markerRef, marker] = useAdvancedMarkerRef();
  const user = useSelector((state) => state.auth?.user);
  // Guard: a partner-viewer session (or a transient null user) would crash the
  // whole map here on `user.host` — and `imageBaseUrl` is only used by the
  // vehicle info-window anyway, never by Site/stop markers.
  const imageBaseUrl = (user?.host || '') + '/';

  const { headerContent, infoWindow } = useMemo(() => {
    if (item.type === 'start' || item.type === 'end') return VehicleInfoWindow({ item, imageBaseUrl });
    // Route detail: the pin carries its stop(s) + orders — "what does the
    // driver do here?" (Diego, Sep 2026).
    if (item.stops?.length) return StopsInfoWindow({ item });
    // if (item.type === STEP_TYPE.pickup || item.type === STEP_TYPE.delivery) return StopInfoWindow({ item, items });
    return {};
  }, [item, imageBaseUrl]);

  return (
    <>
      <AdvancedMarker
        className={active ? 'm-active' : ''}
        zIndex={active ? 2 : 1}
        position={position}
        onClick={onToggle}
        ref={markerRef}
      >
        {icon}
      </AdvancedMarker>
      {active && headerContent && !disableInfoWindow && (
        <InfoWindow anchor={marker} onCloseClick={onToggle} headerContent={headerContent}>
          {infoWindow}
        </InfoWindow>
      )}
    </>
  );
});

export default Marker;
